import { render, staticRenderFns } from "./FeatureNotAvailable.vue?vue&type=template&id=ca4be7fa&scoped=true&"
import script from "./FeatureNotAvailable.vue?vue&type=script&lang=ts&"
export * from "./FeatureNotAvailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4be7fa",
  null
  
)

export default component.exports